function Error(){
    return(
        <div>
            Erro 404
        </div>
    )

}

export default Error;